import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools';
import { preloadMediaToken } from '@confluence/fabric-media-support/entry-points/preloadMediaToken';
import { preloadSmartCreateEditorData } from '@confluence/smart-create-page-editor/entry-points/preloadSmartCreateEditorData';

export const preloadSmartCreateEditorRoute = async (contentId: string) => {
	return waitForAllReturnWhenError([
		preloadSmartCreateEditorData(contentId),
		preloadMediaToken(contentId),
	]);
};
